import { useState, useEffect, useRef, useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { Link } from "react-router-dom";
import { ObserverContext } from "../../Contexts/ObserverContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBullhorn } from "@fortawesome/free-solid-svg-icons";
import PopupImage from "../../assets/popup.png";
import SLIDE1 from "../../assets/slide-1.jpg";
import SLIDE2 from "../../assets/slide-10.jpg";
import SLIDE3 from "../../assets/slide-3.jpg";

function Slider() {
  const ref = useRef();
  const swiperRef = useRef(null);
  const { activeSection, setActiveSection } = useContext(ObserverContext);
  const [showPopup, setShowPopup] = useState(false);
  const [popupStep, setPopupStep] = useState(1);

  useEffect(() => {
    const timer = setTimeout(() => {
      const popupShown = localStorage.getItem("homePopupShown");
      if (!popupShown) {
        setShowPopup(true);
      }
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => {
    setShowPopup(false);
    localStorage.setItem("homePopupShown", "true");
    localStorage.removeItem("homePopupShown");
  };

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setActiveSection("home");
        console.log("this is updated section", activeSection);
      }
    });
    if (ref && ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [ref]);

  const ctaButtons = (
    <div style={{ display: "flex", gap: "15px", marginTop: "20px", alignItems: "center" }}>
      <Link to="/plans" style={{ textDecoration: "none" }}>
        <button style={{
          height: "48px", padding: "0 24px", backgroundColor: "#0c55c2",
          color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer",
          fontWeight: "600", fontSize: "14px", whiteSpace: "nowrap",
          display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          Checkout Latest Offers
        </button>
      </Link>
      <Link to="/contact" style={{ textDecoration: "none" }}>
        <button style={{
          height: "48px", padding: "0 24px", backgroundColor: "#1abc9c",
          color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer",
          fontWeight: "600", fontSize: "14px", whiteSpace: "nowrap",
          display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          Request Demo
        </button>
      </Link>
    </div>
  );

  return (
    <div id="home" ref={ref}>
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <button className="popup-close" onClick={closePopup}>✕</button>
            {popupStep === 1 && (
              <div className="popup-image-wrapper-demo">
                <img src={PopupImage} alt="More Info" className="popup-image" />
                <Link
                  to="/plans"
                  className="popup-overlay-btn demo-btn center-btn-new"
                  onClick={closePopup}
                >
                  Click here to check Plans
                </Link>
              </div>
            )}
          </div>
        </div>
      )}

      <div
        className="position-relative"
        style={{ position: "relative", display: "flex", paddingBottom: "30px" }}
      >
        {/* Custom Prev Button */}
        <div
          className="slider-nav-item position-absolute h-100 left-0 top-0 d-flex align-items-center px-2 z-2"
          style={{ zIndex: 10 }}
        >
          <div
            onClick={() => swiperRef.current?.slidePrev()}
            className="carousel-nav-btn d-flex justify-content-center align-items-center"
          >
            <BsChevronLeft color="#fff" size={15} />
          </div>
        </div>

        {/* Custom Next Button */}
        <div
          className="slider-nav-item position-absolute h-100 right-0 top-0 d-flex align-items-center px-2 z-2"
          style={{ zIndex: 10 }}
        >
          <div
            onClick={() => swiperRef.current?.slideNext()}
            className="carousel-nav-btn d-flex justify-content-center align-items-center"
          >
            <BsChevronRight color="#fff" size={15} />
          </div>
        </div>

        <Swiper
          modules={[Autoplay, Navigation]}
          loop={true}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          navigation={false}
          slidesPerView={1}
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          style={{ width: "100%" }}
        >
          {/* Slide 1 */}
          <SwiperSlide>
          <div
  className="custom-slider slide1 item position-relative"
  style={{ backgroundImage: `url(${SLIDE1})` }}
>
  <div
    className="container h-100 d-flex flex-column justify-content-center align-items-start"
    style={{paddingTop: "200px" , paddingBottom:"200px"}}
  >
    <div style={{ maxWidth: "60%" }}>   {/* ← ADD THIS WRAPPER */}
      <p className="wow bounceInLeft corausel-text-1 mb-1" data-wow-delay="300ms" style={{ color: "#000000" , fontWeight: "bold" }}>
        Providing ERP and Business Automation Solutions Since 1995
      </p>
     <h1
  className="wow bounceInLeft corausel-text-2 mb-3 mobile-font-size"
  data-wow-delay="300ms"
  style={{ color: "rgb(3, 42, 88)" , fontWeight: "bold" }}
>
  Best ERP Software Company in India for Manufacturing, Pharmaceutical, Retail & Schools
  {/* ERP for Manufacturing, Pharmaceuticals,<br /> Retail and Schools */}
</h1>

      <p className="wow bounceInLeft corausel-text-3 mb-3" data-wow-delay="300ms" style={{ color: "rgb(3, 42, 88)", fontSize : "16px" , fontWeight : "600"}}>
        For over two decades, Access Infotech Pvt Ltd has empowered
        manufacturing enterprises with enterprise-grade ERP solutions
        that streamline operations, boost efficiency, and drive growth.
        Our flagship product AccessONE, transforms production,
        inventory, sales, and HR management resulting in significant
        cost savings and exponential revenue growth through standardized
        processes and data-driven insights.
      </p>
      <p className="wow bounceInLeft corausel-text-4 mb-3" data-wow-delay="300ms" style={{ color: "rgb(3, 42, 88)" , fontWeight: "bold" }} >
        <FontAwesomeIcon icon={faBullhorn} size="l" style={{ color: "rgb(3, 42, 88)" , fontWeight: "bold" }} /> Discover AccessONE, our latest release!
      </p>
      {ctaButtons}
    </div>   {/* ← CLOSE WRAPPER */}
  </div>
</div>
          </SwiperSlide>

          {/* Slide 2 */}
          <SwiperSlide>
       <div
  className="custom-slider slide2 item position-relative"
  style={{ backgroundImage: `url(${SLIDE2})` }}
>
  <div className="container h-100 d-flex flex-column justify-content-center align-items-start"
   style={{paddingTop: "200px" , paddingBottom:"200px"}}>
    <div style={{ maxWidth: "60%" }}>   {/* ← ADD THIS WRAPPER */}
      <p className="wow bounceInLeft corausel-text-1 mb-1" data-wow-delay="300ms" style={{ color: "#000000" , fontWeight: "bold" }}>
        AccessONE Enterprise Resource Planning
      </p>
      <h2 className="wow bounceInLeft corausel-text-2 mb-3 mobile-font-size" data-wow-delay="300ms"
       style={{ color: "rgb(3, 42, 88)" , fontWeight: "bold" }}>
        AccessOne Manufacturing ERP Software – Complete Production & Inventory Management Solution
        {/* Revolutionize Manufacturing,<br /> with AccessOne ERP */}
      </h2>
      <p className="wow bounceInLeft corausel-text-1 mb-1" data-wow-delay="300ms" style={{ color: "rgb(3, 42, 88)" , fontWeight: "bold" }}>
        Power-Packed Features
      </p>
      <ul style={{ listStyleType: "disc", paddingLeft: "20px", color: "rgb(3, 42, 88)", lineHeight: "1.0", marginBottom: "20px" , fontWeight: "bold"}} >
        <li>
          For 25+ years, Access Infotech Pvt Ltd has been delivering<br></br>
          battle-tested ERP solutions like AccessONE, slashing costs significantly,<br></br>
          automating production, and supercharging growth for manufacturers worldwide.
        </li>
        <br />
        <li>
          <strong>Lightning-Fast Production Insights:</strong> Real-time dashboards<br></br> track output,
          bottlenecks, and resources—zero<br></br> downtime, max throughput.
        </li>
        <br />
        <li>
          <strong>Smart Inventory Mastery:</strong> AI-driven forecasting <br></br>prevents stockouts,
          cuts waste, and streamlines supply chains<br></br> for non-stop operations.
        </li>
      </ul>
      {ctaButtons}
    </div>   {/* ← CLOSE WRAPPER */}
  </div>
</div>
          </SwiperSlide>

          {/* Slide 3 */}
          <SwiperSlide>
        <div
  className="custom-slider slide3 item position-relative"
  style={{ backgroundImage: `url(${SLIDE3})` }}
>
  <div className="container h-100 d-flex flex-column justify-content-center align-items-start"
   style={{paddingTop: "200px" , paddingBottom:"200px"}}>
    <div style={{ maxWidth: "60%" }}>   {/* ← ADD THIS WRAPPER */}
      <p className="corausel-text-1 mb-1" data-wow-delay="300ms" style={{ color: "#000000" , fontWeight: "bold" }} >
        Service Since 1995
      </p>
      <h3 className="corausel-text-2 mb-3 mobile-font-size" data-wow-delay="300ms"
       style={{ color: "rgb(3, 42, 88)" , fontWeight: "bold" }}>
        {/* Access Infotech Pvt Ltd. */}
        Access Infotech Pvt. Ltd. – Leading ERP Software Company in India
      </h3>
      <p className="corausel-text-3 mb-3" data-wow-delay="300ms" style={{ color: "rgb(3, 42, 88)" , fontSize : "16px" , fontWeight : "600"}}>
        Empower your manufacturing enterprise with Access Infotech's
        Access One ERP software for manufacturing—purpose-built to
        streamline production, inventory, sales, and finance for growing
        businesses in India and worldwide. Our cloud-based ERP solution
        for manufacturing enterprises helps reduce costs, improve
        on-time delivery, and give real-time visibility across plants,
        warehouses, and branches. From production planning and inventory
        control to order management and custom reports, our
        enterprise-grade manufacturing ERP system is designed to support
        SMEs and large enterprises looking to scale efficiently.
      </p>
      {ctaButtons}
    </div>   {/* ← CLOSE WRAPPER */}
  </div>
</div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
}

export default Slider;